import { SyntheticEvent } from 'react';

import { window } from './browser';
import { ModifierKeyState } from './types';

export function convertRemToPx(remValue: string | number) {
  const documentStyle = window?.getComputedStyle(document.documentElement);
  const documentFontSize = documentStyle?.fontSize
    ? parseInt(documentStyle.fontSize, 10)
    : 16;
  const remFactor =
    typeof remValue === 'string' ? parseFloat(remValue) : remValue;

  return remFactor * documentFontSize;
}

export function stopPropagation(e: SyntheticEvent) {
  e.stopPropagation();
}

export function isMetaKeyPressed(modifierKeyState: ModifierKeyState) {
  // TODO: check OS
  return modifierKeyState.metaKey || modifierKeyState.ctrlKey;
}
